import { Link } from "react-router-dom";
import { useAuth } from "../AuthContext";
import { useState } from "react";
import RecruitGlanceLogo from "./RecruitGlanceLogo";
import NotificationBell from "./NotificationBell";

export default function Navbar() {
  const { user, logout } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);
  const hasUser = Boolean(user && user.email);
  const isPilot = user?.plan === "pilot";

  return (
    <nav className="fixed top-0 left-0 w-full h-16 bg-white/80 backdrop-blur border-b border-slate-200 z-50">
      <div
        className={
          hasUser
            ? "mx-auto grid h-full w-full max-w-[1760px] grid-cols-[1fr_auto] items-center px-4 sm:px-6 lg:grid-cols-[16rem_minmax(0,1fr)] lg:px-0"
            : "mx-auto grid h-full w-full max-w-[1760px] grid-cols-[auto_minmax(0,1fr)_auto] items-center gap-3 px-3 sm:gap-6 sm:px-6"
        }
      >
        {/* LEFT: Logo container */}
        <div className={hasUser ? "flex h-full min-w-0 items-center lg:bg-[#03140f] lg:px-4" : "flex min-w-0 items-center"}>
          <RecruitGlanceLogo dark={hasUser} />
        </div>

        {!hasUser && (
          <div className="hidden justify-center md:flex">
            <div className="inline-flex items-center gap-1 rounded-full border border-slate-200 bg-white/85 p-1 text-sm font-semibold text-slate-600 shadow-sm backdrop-blur">
              <a href="/#product-tour" className="rounded-full px-4 py-2 transition hover:bg-emerald-50 hover:text-emerald-900">
                Product
              </a>
              <a href="/#workflow" className="rounded-full px-4 py-2 transition hover:bg-emerald-50 hover:text-emerald-900">
                Workflow
              </a>
              <a href="/#pricing" className="rounded-full px-4 py-2 transition hover:bg-emerald-50 hover:text-emerald-900">
                Pricing
              </a>
              <a href="/#trust" className="rounded-full px-4 py-2 transition hover:bg-emerald-50 hover:text-emerald-900">
                Trust
              </a>
              <a href="/#contact" className="rounded-full px-4 py-2 transition hover:bg-emerald-50 hover:text-emerald-900">
                Contact
              </a>
            </div>
          </div>
        )}

        {/* RIGHT: Edge-aligned actions */}
        <div className={hasUser ? "flex items-center justify-end lg:px-6" : "flex items-center justify-end"}>
          {hasUser ? (
            <div className="flex items-center gap-3">
              <NotificationBell />
              <div className="relative">
              <button
                onClick={() => setMenuOpen((prev) => !prev)}
                className="bg-[#064e3b] text-white px-4 py-2 rounded-md hover:bg-[#04382b] transition"
              >
                {user.first_name || user.email}
              </button>

              {menuOpen && (
                <div className="absolute right-0 mt-2 w-56 bg-[#03140f] border border-white/10 rounded-xl shadow-2xl overflow-hidden z-50">
                  
                  {/* USER INFO */}
                  <div className="px-4 py-3 border-b border-white/10">
                    <p className="text-sm font-semibold text-white truncate">
                      {user.first_name || user.email}
                    </p>
                    <p className="text-xs text-gray-400 truncate">
                      {user.email}
                    </p>
                    <div className="mt-3 flex items-center justify-between rounded-lg border border-white/10 bg-white/5 px-3 py-2">
                      <span className="text-xs font-medium text-gray-400">
                        Plan
                      </span>
                      <span className="text-xs font-semibold uppercase tracking-wide text-white">
                        {user.plan || "free"}
                      </span>
                    </div>
                  </div>

                  {/* MENU ITEMS */}
                  <div className="p-1">

                    <Link
                      to="/dashboard_recruiter"
                      onClick={() => setMenuOpen(false)}
                      className="block px-3 py-2 text-sm text-gray-200 hover:bg-white/5 rounded-lg transition"
                    >
                      🏠 Dashboard
                    </Link>

                    {!isPilot && (
                    <Link
                      to="/profile"
                      onClick={() => setMenuOpen(false)}
                      className="block px-3 py-2 text-sm text-gray-200 hover:bg-white/5 rounded-lg transition"
                    >
                      👤 Profile
                    </Link>
                    )}

                    <button
                      onClick={() => {
                        logout();
                        setMenuOpen(false);
                      }}
                      className="w-full text-left px-3 py-2 text-sm text-red-400 hover:bg-red-500/10 rounded-lg transition"
                    >
                      🚪 Logout
                    </button>

                  </div>
                </div>
              )}
              </div>
            </div>
          ) : (
            <div className="flex items-center gap-2 sm:gap-4">
              <Link
                to="/login"
                className="inline-flex h-10 items-center justify-center whitespace-nowrap rounded-md bg-emerald-700 px-3 text-xs font-semibold text-white transition hover:bg-emerald-800 sm:px-4 sm:text-sm"
              >
                Login
              </Link>
              <Link
                to="/register"
                className="inline-flex h-10 items-center justify-center whitespace-nowrap rounded-md bg-green-600 px-3 text-xs font-semibold text-white transition hover:bg-green-700 sm:px-5 sm:text-sm"
              >
                <span className="sm:hidden">Start free</span>
                <span className="hidden sm:inline">Start free with 5 scans</span>
              </Link>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
}
